import React from 'react';
import ActionButton from '../../ActionButton/ActionButton';
import { ResultSection } from './ResultSection';
import StandardForm from './FormSection/StandardForm';
import ProductForm from './FormSection/ProductForm';
import MeetingNoteForm from './FormSection/MeetingNoteForm';

export const MatchLazyPacks = ({
  intl,
  inputOptions,
  onValueChange,
  onTraitsChange,
  client,
  onSend,
  options,
  onGoToLazyPack,
  text,
  type
}) => {
  let formContent;
  switch (type?.toLowerCase()) {
    case 'product':
      formContent = (
        <ProductForm
          intl={intl}
          inputOptions={inputOptions}
          onValueChange={onValueChange}
          onTraitsChange={onTraitsChange}
          client={client}
        />
      );
      break;
    case 'meeting_notes':
      formContent = (
        <MeetingNoteForm
          intl={intl}
          inputOptions={inputOptions}
          onValueChange={onValueChange}
          onTraitsChange={onTraitsChange}
          client={client}
        />
      );
      break;
    default:
      formContent = (
        <StandardForm
          intl={intl}
          inputOptions={inputOptions}
          onValueChange={onValueChange}
          onTraitsChange={onTraitsChange}
          client={client}
        />
      );
      break;
  }

  // Plain flex column (not MUI Grid spacing): the scrolling body has to keep its
  // own scroller on iOS when this is opened above MeetingDialog's body-scroll-lock.
  //
  // The CTA scrolls WITH the form rather than sitting in a pinned footer. It
  // used to be pinned, which made this the only AI drawer where the button was
  // not where the form ended — every other one runs 表單 → CTA → 結果, and a
  // button floating over a form the adviser is still filling in reads as
  // something to press now.
  return (
    <div
      data-body-scroll-lock-ignore="true"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%'
      }}
    >
      <div
        data-body-scroll-lock-ignore="true"
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch'
        }}
      >
        {formContent}
        <ActionButton onClick={onSend} style={{ margin: '8px 0' }}>
          {intl.formatMessage({ id: 'gpt-lazy-packs-recommend-cta' })}
        </ActionButton>
        {text ? <ResultSection intl={intl} options={options} onGoToLazyPack={onGoToLazyPack} text={text} /> : null}
      </div>
    </div>
  );
};

export default MatchLazyPacks;
